import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';

interface ErrorConfig {
  title: string;
  message: string;
  buttonText: string;
  redirectUrl: string;
  image: string;
}

@Component({
  selector: 'app-error-reusable',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './error-reusable.html',
  styleUrls: ['./error-reusable.css'],
})
export class ErrorReusableComponent implements OnInit {
  errorCode: string = '404';

  errorConfig: Record<string, ErrorConfig> = {
    '401': {
      title: 'Unauthorized',
      message: 'You need to login to access this page.',
      buttonText: 'Go to Login',
      redirectUrl: '/login',
      image: '/Error-images/401 (2).svg',
    },
    '402': {
      title: 'Access Restricted',
      message: 'You don\u2019t have permission to view this page.',
        buttonText: 'Back to Login',
        redirectUrl: '/login',
      image: '/Error-images/402.svg',
    },
    '404': {
      title: 'Page Not Found',
      message: 'The page you are looking for does not exist.',
      buttonText: 'Go Home',
      redirectUrl: '/',
      image: '/Error-images/404.svg',
    },
  };

  errorData: ErrorConfig = this.errorConfig['404'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.paramMap.get('code');
    const overrideMessage = this.route.snapshot.queryParamMap.get('message');
    this.errorCode = code ?? '404';

    const config = this.errorConfig[this.errorCode] || this.errorConfig['404'];

    this.errorData = {
      ...config,
      message: overrideMessage?.trim() || config.message,
      image: config.image || '/Error-images/404.svg',
    };
  }

  onActionClick(): void {
    if (this.errorCode === '401') {
      void this.router.navigateByUrl('/login', { replaceUrl: true });
      return;
    }

    // A 404 means a bad URL, not a bad session — sending the user home must not
    // sign them out. `/` resolves to the dashboard when authenticated and to
    // /login when not.
    this.router.navigateByUrl(this.errorData.redirectUrl);
  }
}
